<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'

export default
{
    name: 'mv-question-form',

    components: { VueEditor },

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {
          editorSettings: {
              imageResize: {},
          },
        }
    },
}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TITLE') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <vue-editor
            v-if="locale == 'hu'"
            :editorOptions="editorSettings"
            v-model="model.description">
            </vue-editor>

        <vue-editor
            v-if="locale == 'en'"
            :editorOptions="editorSettings"
            v-model="model.description_en">
            </vue-editor>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/QuestionForm.vue